import {useEffect, useState} from "react";
import s from "./index.module.scss";
import {FormItem, RadioGroup, SwitchButton} from "../../../componets/form";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../../store";
import {setSessionConfig} from "../../../features/userSettings/actions/setSessionConfig";
import {useTranslation} from "react-i18next";

export const InactiveSessionsSettings = (props: { value: string }) => {
	const [isShown, setIsShown] = useState(props.value !== '');
	const [value, setValue] = useState('');
	const dispatch = useDispatch<AppDispatch>();
	const { t } = useTranslation();
	useEffect(() => {
		if (props.value === '') {
			setIsShown(false);
			setValue('');
		} else {
			setIsShown(true)
			setValue(props.value);
		}
	}, [props.value]);
	return (
		<div>
			<div className={s.row}>
				<SwitchButton
					label={t('sessionTtlTitle')}
					onClick={(checked) => {
						setIsShown(checked);
						if (!checked) {
							dispatch(setSessionConfig({
								type: 'off'
							}))
						}
					}}
					checked={isShown}
					loading={false}
				/>
			</div>
			{isShown && (
				<FormItem name="account_summary" className={s.radio}>
					<RadioGroup
						isQuiz
						isSettings
						defaultValue={value}
						options={['1 WEEK', '2 WEEKS', '1 MONTH', '3 MONTHS'].map((value) => ({
							value,
							label: t(value)
						}))}
						onChange={(param) => {
							setValue(param);
							dispatch(setSessionConfig({
								type: 'on',
								param,
							}))
						}}
					/>
				</FormItem>
			)}
		</div>
	)
}

export default InactiveSessionsSettings;
